import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageWrapperComponent } from './page-wrapper/page-wrapper.component';
import { RouterModule } from '@angular/router';
import { BackBtnComponent } from './back-btn/back-btn.component';
import { Ng5SliderModule } from 'ng5-slider';
import { MainNavComponent } from './main-nav/main-nav.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { FiltersComponent } from './filters/filters.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PwEyeComponent } from './pw-eye/pw-eye.component';
import { PhotoUploadingInstructionsComponent } from './photo-uploading-instructions/photo-uploading-instructions.component';
import { ProgressComponent } from './progress/progress.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { PhotoUploadingGuideComponent } from './photo-uploading-guide/photo-uploading-guide.component';
import { NgxMatIntlTelInputModule } from 'ngx-mat-intl-tel-input';
import { SwitcherComponent } from './switcher/switcher.component';

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    PageWrapperComponent,
    BackBtnComponent,
    MainNavComponent,
    FiltersComponent,
    PwEyeComponent,
    PhotoUploadingInstructionsComponent,
    ProgressComponent,
    PhotoUploadingGuideComponent,
    SwitcherComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    Ng5SliderModule,
    NgxPaginationModule,
    MatDialogModule,
    MatRippleModule,
    MatButtonModule,
    LottieModule.forRoot({player: playerFactory}),
    NgxMatIntlTelInputModule,
  ],
  exports: [
    CommonModule,
    PageWrapperComponent,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    BackBtnComponent,
    Ng5SliderModule,
    MainNavComponent,
    NgxPaginationModule,
    FiltersComponent,
    PwEyeComponent,
    PhotoUploadingInstructionsComponent,
    ProgressComponent,
    MatDialogModule,
    MatRippleModule,
    MatButtonModule,
    LottieModule,
    PhotoUploadingGuideComponent,
    NgxMatIntlTelInputModule,
    SwitcherComponent,
  ],
  providers: [
  ]
})
export class SharedModule {
}
